import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { loginUrl, safeNext } from "../lib/auth";

/** Shared frame for the sign-in page — no portal chrome. */
export function AuthFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-paper px-4 py-12">
      <div className="w-full max-w-sm rounded-lg border border-rule bg-surface p-8 shadow-sm">
        <img
          src="/garyseconomics_logo.webp"
          alt="garyseconomics"
          className="mb-6 block h-7 w-auto"
        />
        {children}
      </div>
    </div>
  );
}

const BUTTON_CLASSES =
  "w-full rounded-md bg-brand-indigo px-4 py-2.5 text-center text-sm font-semibold text-ink-on-dark transition-colors hover:bg-brand-indigo-deep disabled:opacity-50";

export { BUTTON_CLASSES };

const ERROR_MESSAGES: Record<string, string> = {
  refused:
    "We couldn't sign you in to the portal. If you think you should have access, contact the person who invited you.",
  unavailable: "Sign-in isn't available right now. Please try again in a moment.",
};

/**
 * Landing page for a failed sign-in (the proxy redirects here with ?error=…).
 * Reached with no error, it just starts the sign-in.
 */
export function SignIn() {
  const [params] = useSearchParams();
  const next = safeNext(params.get("next"));
  const error = params.get("error");
  const message = error ? (ERROR_MESSAGES[error] ?? ERROR_MESSAGES.unavailable) : null;

  useEffect(() => {
    if (!message) window.location.assign(loginUrl(next));
  }, [message, next]);

  if (!message) return <div className="h-full bg-paper" />;

  return (
    <AuthFrame>
      <h1 className="text-lg font-semibold text-ink">Sign in</h1>
      <p className="mt-3 text-sm text-ink-muted">{message}</p>
      <button
        onClick={() => window.location.assign(loginUrl(next))}
        className={`mt-6 ${BUTTON_CLASSES}`}
      >
        Sign in
      </button>
    </AuthFrame>
  );
}
